export default "__VITE_ASSET__BYNVKSgW__"